import { FC } from "react";
import { DataTable } from "@ventumsoftware/react-toolkit";

export const ShowDnssecKeysModal: FC<{ keys: { protocol: number; flags: number; alg: number; pub_key: string }[] }> = ({
  keys,
}) => {
  return (
    <>
      <div className={"pb-4 flex-1"}>
        <DataTable
          data={keys}
          keyProperty={"pub_key"}
          columns={[
            { header: "Protocol", property: "protocol" },
            { header: "Flags", property: "flags" },
            { header: "Algorithm", property: "alg" },
            {
              header: "Public key",
              property: "pub_key",
              transform: (value: string) => <div className={"break-all"}>{value}</div>,
            },
          ]}
        />
      </div>
    </>
  );
};
